import { DployTheme } from "../dployTheme";
import * as e from "./element-dense";
import { Theme, createTheme, ThemeOptions } from "@material-ui/core/styles";

export const name = "Element (Compact)";
export const id = "element_compact";

export const muiTheme = (theme: Theme): Theme => {
	theme = createTheme({
		...e.muiTheme(theme),
		props: {
			...e.muiTheme(theme).props,
			MuiAutocomplete: { size: "small" }
		}
	});

	return createTheme(theme, compact(theme));
};
const compact = (theme: DployTheme): ThemeOptions => {
	const dense = e.dense(theme);
	return {
		...dense,
		overrides: {
			...dense.overrides,
			MuiGrid: {
				...dense.overrides?.MuiGrid,
				item: {
					...dense.overrides?.MuiGrid?.item,
					padding: 2
				},
				"spacing-xs-2": {
					padding: 2
				}
			},
			MuiFormControl: {
				...dense.overrides?.MuiFormControl,
				marginNormal: {
					...dense.overrides?.MuiFormControl?.marginNormal,
					marginTop: 6,
					marginBottom: 8
				}
			},
			MuiAutocomplete: {
				...dense.overrides?.MuiAutocomplete,
				inputRoot: {
					...dense.overrides?.MuiAutocomplete?.inputRoot,
					padding: "1px !important"
				}
			},
			MuiOutlinedInput: {
				...dense.overrides?.MuiOutlinedInput,
				inputMarginDense: {
					...dense.overrides?.MuiOutlinedInput?.inputMarginDense,
					padding: 14,
					paddingTop: 5,
					paddingBottom: 5
				}
			},
			MuiPaper: {
				elevation1: {
					boxShadow: "none"
				}
			},
			MuiAccordion: {
				root: {
					"&:before": {
						height: 0
					}
				}
			},
			DployFormLiteral: {
				...dense.overrides?.DployFormLiteral,
				root: {
					...dense.overrides?.DployFormLiteral?.root,
					fontSize: 11
				},
				marginNormal: {
					...dense.overrides?.DployFormLiteral?.marginNormal,
					marginTop: 6,
					marginBottom: 8
				}
			},
			DployTextFieldLabel: {
				shrink: {
					transform: "translate(0, -16px) !important"
				}
			}
		}
	};
};
